// faqStrings.ts
import  React  from "react";
import { ReactNode } from "react";
import { Container, Row, Col, Image } from 'react-bootstrap';
//CHAT GPT 
//https://chatgpt.com/c/68430a6b-42f0-800d-904f-9511b9e6a0b4


import BizInsurnaceServices_DATA from "../Insurance-Legacy/insurance-data-documents/InsuranceData-Business_v03a-Images-stock_v03-DocLinks.json";
import PersonalInsurnaceServices_DATA from "../Insurance-Legacy/insurance-data-documents/InsuranceData-Personal_v03-Images-stock.json";

import { IAppConfig, AppConfig, 
          IAddress, 
          IFAQDataDoc,
          IFAQDataDoc_v2_WithSUB,
          IFaqItem, 
          IImagePath, 
          IMetricsRowData,
          IPageContactUs,
          CompanyAddress, IOperatingHours, OperatingHours, 
          IPageAbout,
          IItemList,
          ICategoryItem, IInsuranceCategories as IInsuranceCategories, ItemListBenefits} from "../App_v01_Interfaces";


const mOperatingHours: IOperatingHours = 
new OperatingHours("Mon–Fri: 8am – 5pm MT", "Sat - Call your agent direct", "Sun - Call your agent direct")

const mAddress : IAddress = new CompanyAddress("1312 17th St", "Suite: 364", "Denver", "CO", "80202")


export const FAQ_Page_DATA: IFAQDataDoc_v2_WithSUB = 
{
  title:'Frequently Asked Questions',
  items:
[
  {
    "category": "Auto Insurance",
    "icon": "bi bi-car-front",
    "items": [
      {
        "question": "What does auto insurance cover?",
        "answer": "Auto insurance typically covers liability for bodily injury and property damage, as well as optional coverage like collision, comprehensive, medical payments, and uninsured/underinsured motorists."
      },
      {
        "question": "Is auto insurance mandatory?",
        "answer": "Yes, most states require drivers to carry at least liability insurance. Some states also mandate personal injury protection (PIP) or uninsured motorist coverage."
      }
    ]
  },
  {
    "category": "Homeowners Insurance",
    "icon": "bi bi-house-door",
    "items": [
      {
        "question": "What is covered under a standard homeowners insurance policy?",
        "answer": "A standard policy typically covers your home, personal belongings, liability for injuries or damage, and additional living expenses if you're temporarily displaced."
      },
      {
        "question": "Do I need homeowners insurance if I own my home outright?",
        "answer": "While it’s not legally required, homeowners insurance is highly recommended to protect against financial loss due to damages or liability claims."
      }
    ]
  },
  {
    "category": "Life Insurance",
    "icon": "bi bi-heart-pulse",
    "items": [
      {
        "question": "What is the difference between term and whole life insurance?",
        "answer": "Term life insurance provides coverage for a specific period, while whole life insurance provides lifelong coverage and includes a savings component called cash value."
      },
      {
        "question": "Do I need life insurance if I'm single with no dependents?",
        "answer": "It depends. Life insurance can still be useful to cover final expenses, outstanding debts, or leave a legacy to loved ones or a charity."
      }
    ]
  },
    {
    "category": "Business Insurance",
    "icon": "bi bi-briefcase",
    "items": [
      {
        "question": "What is business insurance?",
        "answer": "Business insurance is a type of coverage that protects businesses from financial losses due to unexpected events such as accidents, lawsuits, property damage, and other risks."
      },
      {
        "question": "Do I need business insurance if I work from home?",
        "answer": "Yes, even home-based businesses face risks like client injuries, data breaches, or equipment damage that may not be covered by homeowners insurance."
      },
      {
        "question": "What types of business insurance are most common?",
        "answer": "Common types include general liability insurance, commercial property insurance, workers’ compensation, professional liability (E&O), and business interruption insurance."
      },
      {
        "question": "How much does business insurance cost?",
        "answer": "Costs vary based on your industry, number of employees, location, and coverage types. Small businesses may pay a few hundred to several thousand dollars annually."
      },
      {
        "question": "Is business insurance required by law?",
        "answer": "Some types, like workers’ compensation or commercial auto insurance, may be legally required depending on your state and business structure."
      },
      {
        "question": "Can I bundle different types of business insurance?",
        "answer": "Yes, many insurers offer Business Owner’s Policies (BOPs), which combine general liability and property insurance at a lower cost than buying separately."
      }
    ]
  },
  {
    "category": "Claims",
    "icon": "bi bi-file-earmark-text",
    "items": [
      {
        "question": "How do I file a claim?",
        "answer": "You can file a claim by calling our claims hotline, logging into your online account, or contacting your agent. Be prepared to provide details of the incident and any supporting documents."
      },
      {
        "question": "How long does it take to process a claim?",
        "answer": "Claim processing times vary depending on the type and complexity, but most claims are processed within 7–14 business days."
      }
    ]
  },
  {
    "category": "General Questions",
    "icon": "bi bi-info-circle",
    "items": [
      {
        "question": "Can I manage my policy online?",
        "answer": "Yes, you can view your policy, make payments, file claims, and update your information through our online portal or mobile app."
      },
      {
        "question": "What discounts are available?",
        "answer": "We offer discounts for bundling policies, safe driving, home security systems, paperless billing, and more. Contact us to learn which discounts apply to you."
      }
    ]
  }
]
}


const mImagePaths: IImagePath[] = [
  {remarks:"Logo Image Path", imageName:"NA",   imagePath: "/insurance/images/"},
]//end

export const Page_ContactUs_DATA: IPageContactUs = {
    Headline :  <>
                  <h2>Contact Us</h2>
                  <p>
                      We’re here to help you manage your risk, protect your family and save you money in the process. <br></br>
                      Whether you need a review, a quote, an update to your policy or have other questions, our team is here to help.
                  </p>
                </>
}

const ImageDirectory = "/insurance/images/businessInsurance/";
const ImageExtension = ".jpeg"
let lAnnma:ReactNode = <span>According to <a href='https://namanow.org/' title='(National Automatic Merchandising Association)'>NAMA</a></span>

export const homePage_01_carouselItems_DATA = [
  {  
    Title: 'Legacy Insurance Services',
    Description: "Our mission is to protect what matters most to you - your home, your business, and ultimately your family's future.",
    src:  ImageDirectory + 'AdobeStock_418731372_Preview' + ImageExtension,
    alt: 'insurance services',
  },
  {
    Title: 'Home and Auto',
    Description: <>Home insurance can cover damage to your home and belongings from events like fire, theft, and natural disasters. <br></br>  
    Auto insurance protects you financially if your vehicle is involved in an accident, stolen, or causes damage.</>,
    src: ImageDirectory + "BizInsurance-BusinessContract_01" + ImageExtension,
    alt: 'Safe and affordiable',
  },
  {
    Title: 'Commercial Insurance',
    Description: "Commercial insurance can protect your business from a host of unforeseen negative events including catastrophic failures, negligence, accidents, employee misconduct and more...",
    src:  ImageDirectory + "AdobeStock_315860783_Preview" + ImageExtension,
    alt: 'High Tech',
  },
  {
    
    Title: 'Health Insurnace',
    Description: 'Can protect individuals and families from potentially high healthcare costs associated with illnesses, injuries, and preventative care.',
    src: ImageDirectory + "WC-HealthInsuranceMeeting01" + ImageExtension,
    alt: 'Health Insurance',
  },
];

const InsuranceTypesList_WORKS: IItemList = {
  Id: 1,
  Title: "Insurnace types ",
  Items: [
    {
      Title: "Fresh, Cold/Hot and satisfying",
      Description: "Fresh snacks and cold drinks are an awesome benefit to everyone who visits your property.",
      ImageLink: "/sundance-images/IMG-AdobeStock_872312240_Preview-water-vend.jpg",
      AltText: "",
      ItemFacts: [
                    {
                        Title: "Fresh and Healthy is in Demand",
                        Description: "Over 60% of millennials and Gen Z consumers actively seek healthier snack options, including fresh fruit, protein bars, low-sugar drinks, and plant-based snacks (Source: Vending Market Watch, 2023). Having fresh vending options meets modern dietary preferences while showing that your property supports wellness.",
                    },
                    {
                        Title: "Cold Drinks Boost Satisfaction",
                        Description: <span>{lAnnma}, beverages—especially bottled water, sodas, and energy drinks—make up nearly 45% of all vending sales. A cold drink on a hot day can increase dwell time and comfort, particularly in high-traffic areas like gyms, offices, or apartment lounges.</span>,
                    },
                    {
                        Title: "Hot Coffee and Snacks Encourage Repeat Visits",
                        Description: "Hot beverage vending machines (especially coffee, espresso, and tea) have seen growing adoption in corporate and shared spaces. Offering high-quality hot drinks in common areas creates a coffee-shop experience and improves workplace morale or tenant loyalty.",
                    },
                    {
                        Title: "Strategic Placement = Higher Usage",
                        Description: "Vending machines placed in easily visible and accessible locations (near entrances, lounges, or lobbies) are more likely to be used multiple times a day. This contributes to increased foot traffic, repeat visits, and even higher perceived value of the space.",
                    },
                    ]
    },
    {
      Title: "Safe and affordiable",
      Description: "Safe, affordiable and valueable benefit to you employees, customers and suppliers.",
      ImageLink: "/sundance-images/IMG-AI-VENDING-01-AdobeStock_1008969090.jpg",
      AltText: "",
      ItemFacts: [
                    {
                        Title: "Contactless and Hygienic",
                        Description: <span>Modern vending machines are equipped with touchless payment options (Apple Pay, Google Pay, RFID, etc.), reducing physical contact and supporting hygiene-conscious environments. According to {lAnnma}, machines that offer contactless payment have seen a 30%+ increase in usage post-COVID (NAMA 2022 Industry Census).</span>,
                    },
                    {
                        Title: "Secure, Tamper-Resistant Design",
                        Description: "Vending machines are built with reinforced locks, tempered glass, and surveillance compatibility. Many commercial-grade machines include anti-vandalism features and are securely anchored, making them safe for high-traffic environments like schools, factories, and transportation hubs.",
                    },
                    {
                        Title: "No Staffing Required",
                        Description: "Because machines are automated and remotely monitored, you eliminate the need for on-site staff or food handling. This makes vending a low-risk and low-maintenance solution for delivering food or beverages.",
                    }
                    ]
    },
    {
      Title: "High Tech / High Touch",
      Description: "The latest technology in vending & Micro markets / Internet & AI aware.",
      ImageLink: "/sundance-images/IMG-VENDING-01-AdobeStock_1044781462.jpg",
      AltText: "",
      ItemFacts: [
                    {
                        Title: "Smart vending - seamless, modern experience",
                        Description: "The latest technology in vending and micro markets is transforming how people access snacks, drinks, and essentials. Today’s smart vending systems are not only sleek and user-friendly — they’re Internet-connected, AI-aware, and built for convenience. This combination of high tech and high touch creates a seamless, modern experience for customers while offering powerful tools and insights for operators and property owners.",
                    },
                    {
                        Title: "Connected to the Internet of Things (IoT)",
                        Description: <span>
                              Modern vending machines are now fully connected to the internet, allowing real-time updates, inventory tracking, and remote maintenance. Operators can monitor stock levels, receive alerts for outages, and even optimize product mix based on buying trends — all remotely.

                              <div className="mt-2 ms-2"><b>Fact:</b> Over 60% of vending machines in the U.S. are now internet-connected, according to Vending Market Watch (2023).</div>
                        </span>,
                    },

       {
                        Title: "Micro Markets: High-Touch Shopping Without the Staff",
                        Description: <span>
                              Micro markets are unattended convenience stores that offer fresh food, drinks, and daily essentials in secure, self-checkout kiosks. They combine vending automation with a retail-like experience—giving customers the freedom to browse, scan, and pay.

                              <div className="mt-2 ms-2"><b>Fact:</b> Micro market installations have grown by 15–20% annually in workplaces and campuses across the U.S. (<a href='https://www.vendingmarketwatch.com/home/company/10283278/automatic-merchandiser-vendingmarketwatch'>Automatic Merchandiser</a> 2023 Report).</div>
                        </span>,
                    },


                    
                    

                    


                    ]
      },
      {
      Title: "Refreshing break rooms",
      Description: "Refresh and recharge in your break room.  Studies show, improved employee productivity and satisfaction.",
      ImageLink: "/sundance-images/IMG-BREAK-ROOM-AdobeStock_1082705275.jpg",
      AltText: "",
      ItemFacts: [
                    {
                        Title: "Boosts Productivity & Satisfaction",
                        Description: "According to a study by the Harvard Business Review, short breaks every 90–120 minutes help employees reset mentally, reduce burnout, and improve focus. Having vending machines in the break room makes those breaks quicker and more accessible, so employees return to work energized.",
                    },
        ]
    },

  ],
};

const InsuranceTypesList: IItemList = {
  Id: 1,
  Title: "Insurnace types ",
  TagLine: "We do the shopping - You get the savings!",
  TagLineUrl: "broker",
  Items: [
    {
      "Title": "Business Insurance",
      "Description": "Insurance designed to protect your businesses from financial losses due to property damage, liability, employee-related risks, operational risks, and more...",
      "ImageLink": "./insurance/images/businessInsurance/BizInsurance-BusinessContract_01.jpeg",
      "AltText": "business Insurance",
      "UrlLink": "businessInsurance",
      "ItemFacts": [
        {
          "Title": "General Liability Insurance",
          "Description": "Protects your business from claims of bodily injury, property damage, and personal injury that occur on your premises or as a result of your operations."
        },
        {
          "Title": "Commercial Property Insurance",
          "Description": "Covers damage to buildings, equipment, inventory, and other physical assets from events like fire, theft, or natural disasters."
        },
        {
          "Title": "Business Interruption Insurance",
          "Description": "Provides compensation for lost income and operating expenses if your business is forced to close temporarily due to a covered event."
        },
        {
          "Title": "Workers’ Compensation Insurance",
          "Description": "Covers medical expenses and lost wages for employees who are injured or become ill on the job. Required in most states."
        },
        {
          "Title": "Professional Liability Insurance (E&O)",
          "Description": "Protects against claims of negligence, misrepresentation, or mistakes in professional services provided to clients."
        },
        {
          "Title": "Commercial Auto Insurance",
          "Description": "Covers vehicles used for business purposes, including liability and physical damage coverage."
        },
        {
          "Title": "Cyber Liability Insurance",
          "Description": "Protects against data breaches, cyberattacks, and other technology-related risks, including notification costs and legal fees."
        },
        {
          "Title": "Directors and Officers (D&O) Insurance",
          "Description": "Covers legal costs and damages for lawsuits brought against a company’s directors or officers for alleged wrongful acts in their managerial roles."
        },
        {
          "Title": "Employment Practices Liability Insurance (EPLI)",
          "Description": "Provides coverage for claims related to wrongful termination, discrimination, sexual harassment, and other employment-related issues."
        },
        {
          "Title": "Product Liability Insurance",
          "Description": "Protects businesses that manufacture or sell products from claims related to injury or damage caused by those products."
        },
        {
          "Title": "Inland Marine Insurance",
          "Description": "Covers goods, equipment, and tools in transit or stored offsite, especially for mobile businesses and contractors."
        },
        {
          "Title": "Commercial Umbrella Insurance",
          "Description": "Provides additional liability coverage that extends beyond the limits of your underlying policies such as general liability or auto liability."
        },
        {
          "Title": "Business Owner’s Policy (BOP)",
          "Description": "A bundled policy that includes general liability and property insurance, often with added coverages tailored to small businesses."
        },
        {
          "Title": "Key Person Insurance",
          "Description": "Covers financial losses to the business due to the death or disability of a key executive or employee."
        },
        {
          "Title": "Fidelity Bonds / Crime Insurance",
          "Description": "Protects against employee theft, embezzlement, and other dishonest acts affecting your business."
        }
        ]
    },
    {
      "Title": "Personal Insurance",
      "Description": "Coverage designed to protect individuals and families from financial loss due to accidents, health issues, property damage, negligence, uninsured motorist and more...",
      "ImageLink": "./insurance/images/businessInsurance/InsuranceCoverageBlocks.jpg",
      "AltText": "personal Insurance",
      "UrlLink": "personalInsurance",
      "ItemFacts": [
        {
          "Title": "Auto Insurance",
          "Description": "Provides financial protection in the event of a car accident, theft, or damage. Covers liability, collision, and comprehensive claims."
        },
        {
          "Title": "Homeowners Insurance",
          "Description": "Covers your home and belongings from risks like fire, theft, storms, and liability for injuries occurring on your property."
        },
        {
          "Title": "Renters Insurance",
          "Description": "Protects personal belongings in a rented home or apartment and provides liability coverage for accidents that happen in your space."
        },
        {
          "Title": "Health Insurance",
          "Description": "Covers medical expenses such as doctor visits, hospital stays, medications, and preventive care services."
        },
        {
          "Title": "Life Insurance",
          "Description": "Provides a death benefit to beneficiaries upon the insured's death. Helps cover expenses and provide financial security to loved ones."
        },
        {
          "Title": "Disability Insurance",
          "Description": "Replaces a portion of your income if you're unable to work due to injury or illness."
        },
        {
          "Title": "Long-Term Care Insurance",
          "Description": "Covers services such as nursing home care, assisted living, and home health care for people with chronic illnesses or disabilities."
        },
        {
          "Title": "Travel Insurance",
          "Description": "Provides coverage for trip cancellations, medical emergencies, lost luggage, and other travel-related risks."
        },
        {
          "Title": "Pet Insurance",
          "Description": "Covers veterinary expenses for illness, injuries, and sometimes routine care for pets."
        },
        {
          "Title": "Umbrella Insurance",
          "Description": "Offers additional liability coverage above and beyond the limits of home, auto, or boat insurance policies."
        },
        {
          "Title": "Condo Insurance",
          "Description": "Protects your unit and personal property, and provides liability coverage specific to condominium owners."
        },
        {
          "Title": "Flood Insurance",
          "Description": "Covers damage to your home and belongings caused by flooding, which is not typically covered by standard homeowners insurance."
        },
        {
          "Title": "Earthquake Insurance",
          "Description": "Provides financial protection against damages caused by earthquakes, which are not included in standard policies."
        },
        {
          "Title": "Mobile Home Insurance",
          "Description": "Covers mobile or manufactured homes from damage, theft, and liability claims."
        },
        {
          "Title": "Motorcycle Insurance",
          "Description": "Covers damage, liability, and medical costs related to motorcycle accidents and theft."
        }
        ]
    },
    {
      "Title": "Insurance Broker vs Captive Agent",
      "Description": "Working with an insurance broker vs. a captive agent offers several distinct benefits, especially when it comes to choice, savings, and personalization. Click here to see a side-by-side comparison to explain the differences.",
      "ImageLink": "./insurance/images/LadyQuestionOPT.png",
      "AltText": "personal Insurance",
      "UrlLink": "broker",
    },
  ],
};

export const homePage_02_FeatureList_Categories_DATA : IInsuranceCategories =
{
    businessInsurance: 
                [
                  {
                    "id": 1,
                    "title": "General Liability Insurance",
                    "description": "Protects your business from claims of bodily injury, property damage, and personal injury that occur on your premises or as a result of your operations."
                  },
                  {
                    "id": 2,
                    "title": "Commercial Property Insurance",
                    "description": "Covers damage to buildings, equipment, inventory, and other physical assets from events like fire, theft, or natural disasters."
                  },
                  {
                    "id": 3,
                    "title": "Business Interruption Insurance",
                    "description": "Provides compensation for lost income and operating expenses if your business is forced to close temporarily due to a covered event."
                  },
                  {
                    "id": 4,
                    "title": "Workers’ Compensation Insurance",
                    "description": "Covers medical expenses and lost wages for employees who are injured or become ill on the job. Required in most states."
                  },
                  {
                    "id": 5,
                    "title": "Professional Liability Insurance (E&O)",
                    "description": "Protects against claims of negligence, misrepresentation, or mistakes in professional services provided to clients."
                  },
                  {
                    "id": 6,
                    "title": "Commercial Auto Insurance",
                    "description": "Covers vehicles used for business purposes, including liability and physical damage coverage."
                  },
                  {
                    "id": 7,
                    "title": "Cyber Liability Insurance",
                    "description": "Protects against data breaches, cyberattacks, and other technology-related risks, including notification costs and legal fees."
                  },
                  {
                    "id": 8,
                    "title": "Directors and Officers (D&O) Insurance",
                    "description": "Covers legal costs and damages for lawsuits brought against a company’s directors or officers for alleged wrongful acts in their managerial roles."
                  },
                  {
                    "id": 9,
                    "title": "Employment Practices Liability Insurance (EPLI)",
                    "description": "Provides coverage for claims related to wrongful termination, discrimination, sexual harassment, and other employment-related issues."
                  },
                  {
                    "id": 10,
                    "title": "Product Liability Insurance",
                    "description": "Protects businesses that manufacture or sell products from claims related to injury or damage caused by those products."
                  },
                  {
                    "id": 11,
                    "title": "Inland Marine Insurance",
                    "description": "Covers goods, equipment, and tools in transit or stored offsite, especially for mobile businesses and contractors."
                  },
                  {
                    "id": 12,
                    "title": "Commercial Umbrella Insurance",
                    "description": "Provides additional liability coverage that extends beyond the limits of your underlying policies such as general liability or auto liability."
                  },
                  {
                    "id": 13,
                    "title": "Business Owner’s Policy (BOP)",
                    "description": "A bundled policy that includes general liability and property insurance, often with added coverages tailored to small businesses."
                  },
                  {
                    "id": 14,
                    "title": "Key Person Insurance",
                    "description": "Covers financial losses to the business due to the death or disability of a key executive or employee."
                  },
                  {
                    "id": 15,
                    "title": "Fidelity Bonds / Crime Insurance",
                    "description": "Protects against employee theft, embezzlement, and other dishonest acts affecting your business."
                  }
                ],

    personalInsurance: [
                {
                  "id": 1,
                  "title": "Auto Insurance",
                  "description": "Provides financial protection in the event of a car accident, theft, or damage. Covers liability, collision, and comprehensive claims."
                },
                {
                  "id": 2,
                  "title": "Homeowners Insurance",
                  "description": "Covers your home and belongings from risks like fire, theft, storms, and liability for injuries occurring on your property."
                },
                {
                  "id": 3,
                  "title": "Renters Insurance",
                  "description": "Protects personal belongings in a rented home or apartment and provides liability coverage for accidents that happen in your space."
                },
                {
                  "id": 4,
                  "title": "Health Insurance",
                  "description": "Covers medical expenses such as doctor visits, hospital stays, medications, and preventive care services."
                },
                {
                  "id": 5,
                  "title": "Life Insurance",
                  "description": "Provides a death benefit to beneficiaries upon the insured's death. Helps cover expenses and provide financial security to loved ones."
                },
                {
                  "id": 6,
                  "title": "Disability Insurance",
                  "description": "Replaces a portion of your income if you're unable to work due to injury or illness."
                },
                {
                  "id": 7,
                  "title": "Long-Term Care Insurance",
                  "description": "Covers services such as nursing home care, assisted living, and home health care for people with chronic illnesses or disabilities."
                },
                {
                  "id": 8,
                  "title": "Travel Insurance",
                  "description": "Provides coverage for trip cancellations, medical emergencies, lost luggage, and other travel-related risks."
                },
                {
                  "id": 9,
                  "title": "Pet Insurance",
                  "description": "Covers veterinary expenses for illness, injuries, and sometimes routine care for pets."
                },
                {
                  "id": 10,
                  "title": "Umbrella Insurance",
                  "description": "Offers additional liability coverage above and beyond the limits of home, auto, or boat insurance policies."
                },
                {
                  "id": 11,
                  "title": "Condo Insurance",
                  "description": "Protects your unit and personal property, and provides liability coverage specific to condominium owners."
                },
                {
                  "id": 12,
                  "title": "Flood Insurance",
                  "description": "Covers damage to your home and belongings caused by flooding, which is not typically covered by standard homeowners insurance."
                },
                {
                  "id": 13,
                  "title": "Earthquake Insurance",
                  "description": "Provides financial protection against damages caused by earthquakes, which are not included in standard policies."
                },
                {
                  "id": 14,
                  "title": "Mobile Home Insurance",
                  "description": "Covers mobile or manufactured homes from damage, theft, and liability claims."
                },
                {
                  "id": 15,
                  "title": "Motorcycle Insurance",
                  "description": "Covers damage, liability, and medical costs related to motorcycle accidents and theft."
                }
              ]
}

// [
    // {
    // "Id": 1,
    // "title": "Busienss Insurance",
    // "itemList": 
    // [
    // {
    //   "title": "Homeowners Insurance",
    //   "description": "Covers damage to your home and personal belongings, and provides liability protection.",
    //   "imageLink": "https://example.com/images/homeowners-insurance.jpg",
    //   "altText": "House with a protective shield overlay",
    //   "items": [
    //     {
    //       "benefit": "Covers fire, theft, and storm damage",
    //       "example": "If a tree falls on your roof during a storm, your insurance covers the cost of repairs and temporary housing."
    //     },
    //     {
    //       "benefit": "Liability coverage for injuries on your property",
    //       "example": "If a delivery person slips on your icy steps and gets hurt, your policy helps cover their medical bills and legal fees."
    //     }
    //   ]
    // },
    // {
    //   "Title": "Auto Insurance",
    //   "Description": "Protects drivers from financial losses related to car accidents, theft, and property damage.",
    //   "ImageLink": "https://example.com/images/auto-insurance.jpg",
    //   "AltText": "Crashed car with insurance form",
    //   "Benefits": [
    //     {
    //       "benefit": "Covers liability for damage to others",
    //       "example": "If you cause an accident that damages another car, your insurance pays for their repairs and medical costs, saving you from a lawsuit."
    //     },
    //     {
    //       "benefit": "Covers vehicle repair or replacement",
    //       "example": "If your car is totaled in a storm, comprehensive coverage helps replace it without draining your savings."
    //     }
    //   ]
    // },
    // {
    //       "Title": "Business Insurance",
    //       "Description": "Covers small to large businesses against risks such as lawsuits, property damage, and income loss.",
    //       "ImageLink": "https://example.com/images/business-insurance.jpg",
    //       "AltText": "Business owner looking at clipboard in warehouse",
    //       "Benefits": [
    //         {
    //           "benefit": "Covers legal costs for liability claims",
    //           "example": "If a customer sues a coffee shop for a hot spill, the policy pays for legal defense and damages."
    //         },
    //         {
    //           "benefit": "Protects inventory and equipment",
    //           "example": "If a fire destroys merchandise, the policy covers replacement costs so the business can reopen quickly."
    //         }
    //       ]
    // },
    // {
    //   "Title": "Health Insurance",
    //   "Description": "Provides coverage for medical expenses such as doctor visits, hospital stays, surgeries, and prescriptions.",
    //   "ImageLink": "https://example.com/images/health-insurance.jpg",
    //   "AltText": "Doctor checking patient's blood pressure",
    //   "Benefits": [
    //     {
    //       "benefit": "Covers routine checkups and emergency care",
    //       "example": "If you break a leg and require surgery and physical therapy, health insurance can cover most of the hospital and treatment costs instead of paying thousands out-of-pocket."
    //     },
    //     {
    //       "benefit": "Reduces out-of-pocket costs for medications",
    //       "example": "A diabetic patient can get insulin for $30/month instead of $400 without insurance."
    //     }
    //   ]
    // },
    // {
    //   "Title": "Renters Insurance",
    //   "Description": "Protects your personal property in a rental unit and includes liability coverage.",
    //   "ImageLink": "https://example.com/images/renters-insurance.jpg",
    //   "AltText": "Young couple unpacking boxes in apartment",
    //   "Benefits": [
    //     {
    //       "benefit": "Replaces stolen or damaged items",
    //       "example": "If your laptop and TV are stolen in a break-in, the policy reimburses you for replacement costs."
    //     },
    //     {
    //       "benefit": "Covers temporary living expenses",
    //       "example": "If a pipe bursts and your unit becomes unlivable, renters insurance covers a hotel stay and meals."
    //     }
    //   ]
    // },
    // {
    //   "Title": "Life Insurance",
    //   "Description": "Pays out a lump sum to beneficiaries after the policyholder’s death to provide financial security.",
    //   "ImageLink": "https://example.com/images/life-insurance.jpg",
    //   "AltText": "Family photo with soft light and sunset",
    //   "Benefits": [
    //     {
    //       "benefit": "Replaces lost income for dependents",
    //       "example": "A family can continue paying their mortgage and utility bills after the primary earner passes away."
    //     },
    //     {
    //       "benefit": "Helps cover funeral expenses",
    //       "example": "The policy can provide $15,000 for burial and funeral costs, easing the financial burden on loved ones."
    //     }
    //   ]
    // },
    // {
    //   "Title": "Disability Insurance",
    //   "Description": "Replaces a portion of income if you become unable to work due to injury or illness.",
    //   "ImageLink": "https://example.com/images/disability-insurance.jpg",
    //   "AltText": "Worker with arm in sling filling out form",
    //   "Benefits": [
    //     {
    //       "benefit": "Provides income during recovery",
    //       "example": "If a back injury prevents a nurse from working for 6 months, disability insurance pays 60% of their salary."
    //     },
    //     {
    //       "benefit": "Helps maintain lifestyle and pay bills",
    //       "example": "Even while not working, the policy covers rent, groceries, and car payments."
    //     }
    //   ]
    // },
    // {
    //   "Title": "Long-Term Care Insurance",
    //   "Description": "Covers extended care services such as nursing homes, assisted living, or home healthcare.",
    //   "ImageLink": "https://example.com/images/long-term-care.jpg",
    //   "AltText": "Caregiver assisting elderly woman",
    //   "Benefits": [
    //     {
    //       "benefit": "Reduces cost of professional care",
    //       "example": "If someone develops Alzheimer’s and needs full-time care, the policy helps cover $5,000/month nursing home fees."
    //     },
    //     {
    //       "benefit": "Preserves retirement savings",
    //       "example": "Rather than depleting a $300,000 retirement account, insurance covers long-term care costs."
    //     }
    //   ]
    // },
    // {
    //   "Title": "Travel Insurance",
    //   "Description": "Protects against trip cancellations, delays, medical emergencies, and lost luggage while traveling.",
    //   "ImageLink": "https://example.com/images/travel-insurance.jpg",
    //   "AltText": "Traveler showing passport at airport",
    //   "Benefits": [
    //     {
    //       "benefit": "Reimburses trip cancellations",
    //       "example": "If a traveler gets sick before an international trip, they’re reimbursed for non-refundable tickets and hotels."
    //     },
    //     {
    //       "benefit": "Provides medical emergency coverage",
    //       "example": "If someone breaks a leg abroad, travel insurance pays for hospital care and emergency evacuation back home."
    //     }
    //   ]
    // },
    // {
    //   "Title": "Pet Insurance",
    //   "Description": "Helps pay for vet bills due to accidents, illnesses, and preventive care.",
    //   "ImageLink": "https://example.com/images/pet-insurance.jpg",
    //   "AltText": "Golden retriever at the vet",
    //   "Benefits": [
    //     {
    //       "benefit": "Covers surgery and emergency care",
    //       "example": "If a dog swallows a toy and needs surgery, insurance covers the $2,500 vet bill."
    //     },
    //     {
    //       "benefit": "Helps with ongoing treatments",
    //       "example": "A cat with diabetes gets covered insulin and checkups through a monthly plan."
    //     }
    //   ]
    // },
    // {
    //   "Title": "Umbrella Insurance",
    //   "Description": "Provides additional liability protection beyond existing auto, home, or renters insurance.",
    //   "ImageLink": "https://example.com/images/umbrella-insurance.jpg",
    //   "AltText": "Umbrella covering family and assets",
    //   "Benefits": [
    //     {
    //       "benefit": "Extends coverage for major lawsuits",
    //       "example": "If you're sued for $1 million after a car accident but your auto policy only covers $300,000, umbrella insurance pays the remaining $700,000."
    //     },
    //     {
    //       "benefit": "Protects assets like savings and property",
    //       "example": "Without it, a court judgment could force you to sell your home or liquidate your investments."
    //     }
    //   ]
    // },
//   ],
//     },
//     {
//       "Id": 1,
//       "Name": "Busienss Insurance",
//       "Items": 
//       [
//       {
//         "Title": "Homeowners Insurance",
//         "Description": "Covers damage to your home and personal belongings, and provides liability protection.",
//         "ImageLink": "https://example.com/images/homeowners-insurance.jpg",
//         "AltText": "House with a protective shield overlay",
//         "Benefits": [
//           {
//             "benefit": "Covers fire, theft, and storm damage",
//             "example": "If a tree falls on your roof during a storm, your insurance covers the cost of repairs and temporary housing."
//           },
//           {
//             "benefit": "Liability coverage for injuries on your property",
//             "example": "If a delivery person slips on your icy steps and gets hurt, your policy helps cover their medical bills and legal fees."
//           }
//         ]
//       },
//       {
//         "Title": "Auto Insurance",
//         "Description": "Protects drivers from financial losses related to car accidents, theft, and property damage.",
//         "ImageLink": "https://example.com/images/auto-insurance.jpg",
//         "AltText": "Crashed car with insurance form",
//         "Benefits": [
//           {
//             "benefit": "Covers liability for damage to others",
//             "example": "If you cause an accident that damages another car, your insurance pays for their repairs and medical costs, saving you from a lawsuit."
//           },
//           {
//             "benefit": "Covers vehicle repair or replacement",
//             "example": "If your car is totaled in a storm, comprehensive coverage helps replace it without draining your savings."
//           }
//         ]
//       },

//       {
//             "Title": "Business Insurance",
//             "Description": "Covers small to large businesses against risks such as lawsuits, property damage, and income loss.",
//             "ImageLink": "https://example.com/images/business-insurance.jpg",
//             "AltText": "Business owner looking at clipboard in warehouse",
//             "Benefits": [
//               {
//                 "benefit": "Covers legal costs for liability claims",
//                 "example": "If a customer sues a coffee shop for a hot spill, the policy pays for legal defense and damages."
//               },
//               {
//                 "benefit": "Protects inventory and equipment",
//                 "example": "If a fire destroys merchandise, the policy covers replacement costs so the business can reopen quickly."
//               }
//             ]
//       },
//       {
//         "Title": "Health Insurance",
//         "Description": "Provides coverage for medical expenses such as doctor visits, hospital stays, surgeries, and prescriptions.",
//         "ImageLink": "https://example.com/images/health-insurance.jpg",
//         "AltText": "Doctor checking patient's blood pressure",
//         "Benefits": [
//           {
//             "benefit": "Covers routine checkups and emergency care",
//             "example": "If you break a leg and require surgery and physical therapy, health insurance can cover most of the hospital and treatment costs instead of paying thousands out-of-pocket."
//           },
//           {
//             "benefit": "Reduces out-of-pocket costs for medications",
//             "example": "A diabetic patient can get insulin for $30/month instead of $400 without insurance."
//           }
//         ]
//       },
//       {
//         "Title": "Renters Insurance",
//         "Description": "Protects your personal property in a rental unit and includes liability coverage.",
//         "ImageLink": "https://example.com/images/renters-insurance.jpg",
//         "AltText": "Young couple unpacking boxes in apartment",
//         "Benefits": [
//           {
//             "benefit": "Replaces stolen or damaged items",
//             "example": "If your laptop and TV are stolen in a break-in, the policy reimburses you for replacement costs."
//           },
//           {
//             "benefit": "Covers temporary living expenses",
//             "example": "If a pipe bursts and your unit becomes unlivable, renters insurance covers a hotel stay and meals."
//           }
//         ]
//       },
//       {
//         "Title": "Life Insurance",
//         "Description": "Pays out a lump sum to beneficiaries after the policyholder’s death to provide financial security.",
//         "ImageLink": "https://example.com/images/life-insurance.jpg",
//         "AltText": "Family photo with soft light and sunset",
//         "Benefits": [
//           {
//             "benefit": "Replaces lost income for dependents",
//             "example": "A family can continue paying their mortgage and utility bills after the primary earner passes away."
//           },
//           {
//             "benefit": "Helps cover funeral expenses",
//             "example": "The policy can provide $15,000 for burial and funeral costs, easing the financial burden on loved ones."
//           }
//         ]
//       },
//       {
//         "Title": "Disability Insurance",
//         "Description": "Replaces a portion of income if you become unable to work due to injury or illness.",
//         "ImageLink": "https://example.com/images/disability-insurance.jpg",
//         "AltText": "Worker with arm in sling filling out form",
//         "Benefits": [
//           {
//             "benefit": "Provides income during recovery",
//             "example": "If a back injury prevents a nurse from working for 6 months, disability insurance pays 60% of their salary."
//           },
//           {
//             "benefit": "Helps maintain lifestyle and pay bills",
//             "example": "Even while not working, the policy covers rent, groceries, and car payments."
//           }
//         ]
//       },
//       {
//         "Title": "Long-Term Care Insurance",
//         "Description": "Covers extended care services such as nursing homes, assisted living, or home healthcare.",
//         "ImageLink": "https://example.com/images/long-term-care.jpg",
//         "AltText": "Caregiver assisting elderly woman",
//         "Benefits": [
//           {
//             "benefit": "Reduces cost of professional care",
//             "example": "If someone develops Alzheimer’s and needs full-time care, the policy helps cover $5,000/month nursing home fees."
//           },
//           {
//             "benefit": "Preserves retirement savings",
//             "example": "Rather than depleting a $300,000 retirement account, insurance covers long-term care costs."
//           }
//         ]
//       },
//       {
//         "Title": "Travel Insurance",
//         "Description": "Protects against trip cancellations, delays, medical emergencies, and lost luggage while traveling.",
//         "ImageLink": "https://example.com/images/travel-insurance.jpg",
//         "AltText": "Traveler showing passport at airport",
//         "Benefits": [
//           {
//             "benefit": "Reimburses trip cancellations",
//             "example": "If a traveler gets sick before an international trip, they’re reimbursed for non-refundable tickets and hotels."
//           },
//           {
//             "benefit": "Provides medical emergency coverage",
//             "example": "If someone breaks a leg abroad, travel insurance pays for hospital care and emergency evacuation back home."
//           }
//         ]
//       },
    
//       {
//         "Title": "Pet Insurance",
//         "Description": "Helps pay for vet bills due to accidents, illnesses, and preventive care.",
//         "ImageLink": "https://example.com/images/pet-insurance.jpg",
//         "AltText": "Golden retriever at the vet",
//         "Benefits": [
//           {
//             "benefit": "Covers surgery and emergency care",
//             "example": "If a dog swallows a toy and needs surgery, insurance covers the $2,500 vet bill."
//           },
//           {
//             "benefit": "Helps with ongoing treatments",
//             "example": "A cat with diabetes gets covered insulin and checkups through a monthly plan."
//           }
//         ]
//       },
//       {
//         "Title": "Umbrella Insurance",
//         "Description": "Provides additional liability protection beyond existing auto, home, or renters insurance.",
//         "ImageLink": "https://example.com/images/umbrella-insurance.jpg",
//         "AltText": "Umbrella covering family and assets",
//         "Benefits": [
//           {
//             "benefit": "Extends coverage for major lawsuits",
//             "example": "If you're sued for $1 million after a car accident but your auto policy only covers $300,000, umbrella insurance pays the remaining $700,000."
//           },
//           {
//             "benefit": "Protects assets like savings and property",
//             "example": "Without it, a court judgment could force you to sell your home or liquidate your investments."
//           }
//         ]
//       },
//     ],
//     }
// ]






     // {
      //   Title: "Home and Auto",
    //   Description: "From airports to cruise ports, avoid the hassle of rideshare apps and experience a smooth, first-class journey every time.",
    //   ImageLink: ImageDirectory + 'AdobeStock_418731372_Preview' + ImageExtension,
    //   alt: 'insurance services',
    //   ItemFacts: [
    //     {
    //       "Title": "Airport Transfers",
    //       "Description": "Reliable, stress-free transport to and from all major airports with flight tracking."
    //     },
    //     {
    //       "Title": "Cruise Port Transfers",
    //       "Description": "Enjoy seamless transfers to your cruise ship with space for luggage and friends."
    //     },
    //     {
    //       "Title": "Hotel & Resort Transfers",
    //       "Description": "Start or end your vacation with a touch of luxury from hotel to destination."
    //     }
    //   ]
    // },




//old code.... 
export const homePage_02_FeatureList_DATA :ItemListBenefits[] =
  [
    {
      "Title": "Homeowners Insurance",
      "Description": "Covers damage to your home and personal belongings, and provides liability protection.",
      "ImageLink": "https://example.com/images/homeowners-insurance.jpg",
      "AltText": "House with a protective shield overlay",
      "Items": [
        {
          "benefit": "Covers fire, theft, and storm damage",
          "example": "If a tree falls on your roof during a storm, your insurance covers the cost of repairs and temporary housing."
        },
        {
          "benefit": "Liability coverage for injuries on your property",
          "example": "If a delivery person slips on your icy steps and gets hurt, your policy helps cover their medical bills and legal fees."
        }
      ]
    },
    {
    "Title": "Auto Insurance",
    "Description": "Protects drivers from financial losses related to car accidents, theft, and property damage.",
    "ImageLink": "https://example.com/images/auto-insurance.jpg",
    "AltText": "Crashed car with insurance form",
    "Items": [
      {
        "benefit": "Covers liability for damage to others",
        "example": "If you cause an accident that damages another car, your insurance pays for their repairs and medical costs, saving you from a lawsuit."
      },
      {
        "benefit": "Covers vehicle repair or replacement",
        "example": "If your car is totaled in a storm, comprehensive coverage helps replace it without draining your savings."
      }
      ]
    },
    {
          "Title": "Business Insurance",
          "Description": "Covers small to large businesses against risks such as lawsuits, property damage, and income loss.",
          "ImageLink": "https://example.com/images/business-insurance.jpg",
          "AltText": "Business owner looking at clipboard in warehouse",
          "Items": [
            {
              "benefit": "Covers legal costs for liability claims",
              "example": "If a customer sues a coffee shop for a hot spill, the policy pays for legal defense and damages."
            },
            {
              "benefit": "Protects inventory and equipment",
              "example": "If a fire destroys merchandise, the policy covers replacement costs so the business can reopen quickly."
            }
          ]
    },
    {
      "Title": "Health Insurance",
      "Description": "Provides coverage for medical expenses such as doctor visits, hospital stays, surgeries, and prescriptions.",
      "ImageLink": "https://example.com/images/health-insurance.jpg",
      "AltText": "Doctor checking patient's blood pressure",
      "Items": [
        {
          "benefit": "Covers routine checkups and emergency care",
          "example": "If you break a leg and require surgery and physical therapy, health insurance can cover most of the hospital and treatment costs instead of paying thousands out-of-pocket."
        },
        {
          "benefit": "Reduces out-of-pocket costs for medications",
          "example": "A diabetic patient can get insulin for $30/month instead of $400 without insurance."
        }
      ]
    },
    {
      "Title": "Renters Insurance",
      "Description": "Protects your personal property in a rental unit and includes liability coverage.",
      "ImageLink": "https://example.com/images/renters-insurance.jpg",
      "AltText": "Young couple unpacking boxes in apartment",
      "Items": [
        {
          "benefit": "Replaces stolen or damaged items",
          "example": "If your laptop and TV are stolen in a break-in, the policy reimburses you for replacement costs."
        },
        {
          "benefit": "Covers temporary living expenses",
          "example": "If a pipe bursts and your unit becomes unlivable, renters insurance covers a hotel stay and meals."
        }
      ]
    },
    {
      "Title": "Life Insurance",
      "Description": "Pays out a lump sum to beneficiaries after the policyholder’s death to provide financial security.",
      "ImageLink": "https://example.com/images/life-insurance.jpg",
      "AltText": "Family photo with soft light and sunset",
      "Items": [
        {
          "benefit": "Replaces lost income for dependents",
          "example": "A family can continue paying their mortgage and utility bills after the primary earner passes away."
        },
        {
          "benefit": "Helps cover funeral expenses",
          "example": "The policy can provide $15,000 for burial and funeral costs, easing the financial burden on loved ones."
        }
      ]
    },
    {
      "Title": "Disability Insurance",
      "Description": "Replaces a portion of income if you become unable to work due to injury or illness.",
      "ImageLink": "https://example.com/images/disability-insurance.jpg",
      "AltText": "Worker with arm in sling filling out form",
      "Items": [
        {
          "benefit": "Provides income during recovery",
          "example": "If a back injury prevents a nurse from working for 6 months, disability insurance pays 60% of their salary."
        },
        {
          "benefit": "Helps maintain lifestyle and pay bills",
          "example": "Even while not working, the policy covers rent, groceries, and car payments."
        }
      ]
    },
    {
      "Title": "Long-Term Care Insurance",
      "Description": "Covers extended care services such as nursing homes, assisted living, or home healthcare.",
      "ImageLink": "https://example.com/images/long-term-care.jpg",
      "AltText": "Caregiver assisting elderly woman",
      "Items": [
        {
          "benefit": "Reduces cost of professional care",
          "example": "If someone develops Alzheimer’s and needs full-time care, the policy helps cover $5,000/month nursing home fees."
        },
        {
          "benefit": "Preserves retirement savings",
          "example": "Rather than depleting a $300,000 retirement account, insurance covers long-term care costs."
        }
      ]
    },
    {
      "Title": "Travel Insurance",
      "Description": "Protects against trip cancellations, delays, medical emergencies, and lost luggage while traveling.",
      "ImageLink": "https://example.com/images/travel-insurance.jpg",
      "AltText": "Traveler showing passport at airport",
      "Items": [
        {
          "benefit": "Reimburses trip cancellations",
          "example": "If a traveler gets sick before an international trip, they’re reimbursed for non-refundable tickets and hotels."
        },
        {
          "benefit": "Provides medical emergency coverage",
          "example": "If someone breaks a leg abroad, travel insurance pays for hospital care and emergency evacuation back home."
        }
      ]
    },  
    {
      "Title": "Pet Insurance",
      "Description": "Helps pay for vet bills due to accidents, illnesses, and preventive care.",
      "ImageLink": "https://example.com/images/pet-insurance.jpg",
      "AltText": "Golden retriever at the vet",
      "Items": [
        {
          "benefit": "Covers surgery and emergency care",
          "example": "If a dog swallows a toy and needs surgery, insurance covers the $2,500 vet bill."
        },
        {
          "benefit": "Helps with ongoing treatments",
          "example": "A cat with diabetes gets covered insulin and checkups through a monthly plan."
        }
      ]
    },
    {
      "Title": "Umbrella Insurance",
      "Description": "Provides additional liability protection beyond existing auto, home, or renters insurance.",
      "ImageLink": "https://example.com/images/umbrella-insurance.jpg",
      "AltText": "Umbrella covering family and assets",
      "Items": [
        {
          "benefit": "Extends coverage for major lawsuits",
          "example": "If you're sued for $1 million after a car accident but your auto policy only covers $300,000, umbrella insurance pays the remaining $700,000."
        },
        {
          "benefit": "Protects assets like savings and property",
          "example": "Without it, a court judgment could force you to sell your home or liquidate your investments."
        }
      ]
    }
];

export const homePage_03_metricsRow_DATA_LIMOS : IMetricsRowData =  {
  Headline : "Limo Industry Metrics",
  Rows: [
        {
          "Title": "Insurance Claims",
          "SubTitle": "Corporate and executive transportation makes up the largest share of limo bookings, driven by airport transfers, meetings, conventions, and recurring business accounts.",
          "Text": "25–30% of bookings"
        },
        {
          "Title": "Risk",
          "SubTitle": "Weddings are a major occasion for luxury limo rentals, offering elegance, coordination for bridal parties, and memorable entrances and exits.",
          "Text": "20–25% of bookings"
        },
        {
          "Title": "Airport Transfers",
          "SubTitle": "Frequent rides to and from airports for individuals and corporate travelers, valued for convenience, reliability, and premium service.",
          "Text": "15–20% of bookings"
        },
        {
          "Title": "Proms & School Dances",
          "SubTitle": "A seasonal spike in spring, where teens book stretch limos or SUV limos to travel in groups safely and in style for prom night.",
          "Text": "10–15% of bookings"
        },
        {
          "Title": "Nightlife / Concerts / Casinos",
          "SubTitle": "Popular for groups seeking stylish, safe transport for nights out, concerts, or casino trips—especially on weekends and holidays.",
          "Text": "10–12% of bookings"
        },
        {
          "Title": "Bachelor/Bachelorette Parties",
          "SubTitle": "Pre-wedding parties often involve bar hopping, nightclubs, or local excursions, with a party-friendly vehicle and chauffeur for the night.",
          "Text": "5–8% of bookings"
        },
        {
          "Title": "Funerals",
          "SubTitle": "Reserved, professional service for families needing respectful transportation to and from memorial services or burial sites.",
          "Text": "2–5% of bookings"
        },
        {
          "Title": "City/Wine/Holiday Tours",
          "SubTitle": "Leisure and sightseeing tours including wine tastings, holiday light routes, or custom city tours—often marketed to tourists or locals celebrating special occasions.",
          "Text": "3–6% of bookings"
        }
      ]
}; //end:



export const homePage_03_metricsRow_DATA : IMetricsRowData =  {
  Headline : "Insurance Industry Metrics",
  Rows:
        [
          {
            "Title": "Auto Claims",
            "SubTitle": "Accidents, theft, and weather-related vehicle damage",
            "Text": "70% of all P&C claims are auto-related"
          },
          {
            "Title": "Homeowners ",
            "SubTitle": "Damage to property from fire, weather, or liability issues",
            "Text": "34% of claims caused by wind/hail"
          },
          {
            "Title": "Health Claims",
            "SubTitle": "Medical care, hospital visits, prescriptions",
            "Text": "1.4 billion+ in claims annually in U.S."
          },
          {
            "Title": "Life Insurance",
            "SubTitle": "Death benefit claims following the policyholder's death",
            "Text": "$90 billion paid out annually in U.S."
          },
          {
            "Title": "Business Insurance Claims",
            "SubTitle": "Claims for liability, property damage, and business interruption",
            "Text": "40% of small businesses file a claim over a 10-year period; theft and water damage are most common."
          },
          {
            "Title": "Workers’ Compensation Claims",
            "SubTitle": "Injuries or illnesses sustained while on the job",
            "Text": "2.6 million nonfatal workplace injuries reported in 2022; average payout ranges from $20,000–$40,000."
          },
          {
            "Title": "Travel Insurance Claims",
            "SubTitle": "Trip cancellations, medical emergencies abroad, lost luggage",
            "Text": "Trip cancellations account for 40% of claims; 90% of valid claims are approved by insurers."
          },
          {
            "Title": "Flood Insurance Claims",
            "SubTitle": "Water damage from natural flooding events",
            "Text": "$1.5 billion paid out by NFIP in 2021; average flood claim payout is approximately $50,000."
          },
          {
            "Title": "Cyber Insurance Claims",
            "SubTitle": "Data breaches, ransomware attacks, and cyber extortion",
            "Text": "Ransomware accounts for 25%+ of claims; average cost per cyber claim is around $150,000."
          },
          {
            "Title": "Pet Insurance Claims",
            "SubTitle": "Veterinary care for illness or accidents",
            "Text": "Average reimbursement per vet visit is $250; most common claims are for stomach issues and infections."
          }
      ]
}; //end:


export const Page_About_DATA_SEE_CUSTOM_PAGE: IPageAbout = {
  Headline: "",
  Services: "",
}

// ---------------------------------------------------
// MAY DO THIS LATER - UPGRADING TO NAMED ARGUMENTS // 
// ---------------------------------------------------
// export const AppConfig_DATA : IAppConfig = new AppConfig(
// {
//     companyDisplayName: "v01b", 
//     companyLegalName: "Legacy Insurance",
//     companyMainPhone: "Legacy Insurace LLC", 
//     infoeMail: "info@LegacyInsurance.com",  
//     supporteMail: "support@LegacyInsurance.com", 
//     supportPhone:  "(720) 927-7141", 
//     legalEMail: "website.legal@LegacyInsurance.com", 
//     contactPageAPIUrl:  "https://wi8zkeven2.execute-api.us-east-1.amazonaws.com/prod/feedback", 
//     address: mAddress, 
//     operatingHours: mOperatingHours, 
//     images: mImagePaths, 
//     faqData: FAQ_Page_DATA, 
//     ContactUsPage: Page_ContactUs_DATA, 
//     AboutPage: Page_About_DATA, 
//     homePageCarouselItems: homePage_01_carouselItems_DATA, 
//     homePageFeaturesList:InsuranceTypesList, 
//     homePageMetrics: homePage_03_metricsRow_DATA, 
//     ServicesPage1: BizInsurnaceServices_DATA, 
//     ServicesPage2: PersonalInsurnaceServices_DATA, 
//     HomePageMetrcsCSSValue:2
//     }

// )//end:


// 9/9/2025 update - added the insurrance carriers to the bottom of the page.
export const AppConfig_DATA : IAppConfig = new AppConfig(
  "v01.1p", 
  "Legacy Insurance",
  "Legacy Insurance Network LLC", 
  '(303) 337-4433', 
  "info@LegacyInsuranceNetwork.com",   
  "support@LegacyInsuranceNetwork.com", 
  "(303) 337-4433", 
  "legal@LegacyInsuranceNetwork.com", 
  "https://wi8zkeven2.execute-api.us-east-1.amazonaws.com/prod/feedback",
    mAddress, 
    mOperatingHours, 
    mImagePaths,
    FAQ_Page_DATA,
    Page_ContactUs_DATA,
    Page_About_DATA_SEE_CUSTOM_PAGE,

    homePage_01_carouselItems_DATA,
    
    // homePage_02_FeatureList_DATA,
    // homePage_02_FeatureList_Categories_DATA,
    InsuranceTypesList,
    homePage_03_metricsRow_DATA,
    

    BizInsurnaceServices_DATA,
    PersonalInsurnaceServices_DATA,
    2
  )//end:



// homePage_01_carouselItems_DATA,
//     homePage_02_FeatureList_DATA,
//     homePage_03_metricsRow_DATA,









// export const FAQ_Page_Dataxx: IFaqItem[] = [
//   {
//     category: 'General Questions - INSURANCE QUESTIONS',
//     icon: 'bi-cup-straw',
//     items: [
//       {
//         question: 'GOOD INSURANCE',
//         answer: 'Snacks, drinks, healthy and customizable options.'
//       },
//       {
//         question: 'Are your machines ADA-compliant and modern?',
//         answer: 'Yes, with cashless payments and real-time monitoring.'
//       },
//       {
//           question: 'What are ADA-compliant vending machines?',
//           answer: 'The Americans with Disabilities Act Standards for Accessible Design.  Therefore, an ADA compliant vending machine must be accessible to those with disabilities.'
          
//         },
//       {
//         question: 'Do you offer healthy or specialty vending options?',
//         answer: 'Yes, including organic, gluten-free, and keto choices.'
//       }
//     ]
//   },
//   {
//     category: 'For Business Owners & Property Managers',
//     icon: 'bi-building',
//     items: [
//       {
//         question: 'What does it cost to install a vending machine?',
//         answer: "It is free - The machine delivery, installation, and service is provided at no cost to the property.  Vending drinks and snacks at fair prices, provides a safe and convenient value added amenity for everyone who visits your property."
//       },
//       {
//         question: 'How do I qualify?',
//         answer: 'We will provide a free evaluation your site to see what machine / design services your visitors best.'
//       },
//       {
//         question: 'Who maintains the machines?',
//         answer: 'We do.  Maintenance, repairs, and refills are included in the service.'
//       },
//       {
//           question: 'What types of machines are provided?',
//           answer: 'We only work with new machines that utilize the latest technology to monitor the inventory and health status of the machine in real time.'
//         }
//     ]
//   },
//   {
//     category: 'Service & Support',
//     icon: 'bi-tools',
//     items: [
//       {
//         question: 'What if the machine breaks?',
//         answer: 'We always monitoring the machine via the internet.  We strive to resolve most issues within 24 hours.'
//       },
//       {
//         question: 'What if someone loses money?',
//         answer: 'We offer full refunds.  We will corrdinate with your manager and/or we offer refunds via phone and/or online form.'
//       }
//     ]
//   },
//   {
//     category: 'Still Have Questions?',
//     icon: 'bi-envelope-paper-heart',
//     items: [
//       {
//         question: 'More questions',
//         answer: <span>Contact us using the <a href='/contact'>contact us form</a> on this website.  We’re happy to help!</span>
//       }
//     ]
//   }
// ];


//SAMPLE ABOUT PAGE EASY TRASH OUT
export const Page_About_DATA_XX: IPageAbout = {
      Headline: 
              <Row className="mb-4">
                <Col md={6}>
                    <h2>About us... &nbsp;<i className="bi bi-emoji-smile fs-3 text-success"></i></h2>
                      <p>
                          At Legacy Insurance , we specialize in INSURANCE! .
                      </p>

                      <p>We are a <strong>locally owned and operated business</strong> committed to making your cleanout process easy and efficient. With a focus on speed, respect, and professionalism, our goal is to leave every space cleaner, safer, and ready for whatever comes next.</p>

                </Col>
                <Col md={6}>
                  {/* <Image
                    src="/images/sundance-dancer-logo.png" // replace with actual logo/image path
                    alt="Sundance Vending Company Logo"
                    fluid
                    className="rounded"
                  /> */}
                </Col>
              </Row>,

  Services:   <Row>
                <Col md={4}>
                  <h5>What We Do</h5>
                  <ul>
                      <li>Junk & Debris Removal</li>
                      <li>Appliance & Furniture Hauling</li>
                      <li>Foreclosure & Eviction Cleanouts</li>
                      <li>Garage, Basement & Attic Cleanups</li>
                      <li>Construction & Renovation Debris Removal</li>
                      <li>Yard Waste Disposal</li>
                  </ul>
                </Col>

                <Col md={4}>
                  <h5>Why Choose Easy Trash Out?</h5>
                  <ul>
                    <li><strong>Prompt, Reliable Service</strong> – Same-day and next-day appointments available</li>
                    <li><strong>Transparent Pricing</strong> – No hidden fees, just honest estimates</li>
                    <li><strong>Eco-Friendly</strong> – We recycle and donate whenever possible</li>
                    <li><strong>Licensed & Insured</strong> – Professional, courteous crew you can trust</li>
                  </ul>
                </Col>

                <Col md={4}>
                  <h5>Our Mission</h5>
                  <ul>
                      <p>To make clutter and debris disappear—quickly, safely, and responsibly—so you can reclaim your space and peace of mind.</p>

                      <h3>Serving Your Community</h3>
                  </ul>
                </Col>
              </Row>
}